import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon: React.ElementType;
  title: string;
  description: string;
  actionText?: string;
  actionHref?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  actionText,
  actionHref
}) => {
  return (
    <div className="flex items-center justify-center h-full p-10 text-center bg-white rounded-md">
      <div className="flex flex-col items-center space-y-4">
        <Icon className="w-12 h-12 text-blue-500" />
        
        <h3 className="text-xl font-bold">
          {title}
        </h3>
        
        <p className="max-w-md text-gray-600">
          {description}
        </p>
        
        {actionText && actionHref && (
          <Link
            to={actionHref}
            className="px-4 py-2 mt-2 font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            {actionText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
